import ApolloClient from 'apollo-boost';
import { queryMe, mutationAuthUser } from './queries/users';
class GraphQLClient {
    constructor() {
        this.client = null;
        this.connect();
        this.onErrorCallbacks = [];
    }
    addOnErrorListener(callback) {
        this.onErrorCallbacks = [...this.onErrorCallbacks, callback];
    }
    connect() {
        const client = new ApolloClient({
            uri: '/graphql',
            credentials: 'include',
            // request: operation => {
            //     // const token = localStorage.getItem('token');
            //     operation.setContext({
            //         headers: {
            //             authorization: token ? `Bearer ${token}` : '',
            //         },
            //     });
            // },
            onError: ({ networkError, graphQLErrors }) => {
                console.log('networkError', networkError);
                console.log('graphQLErrors', graphQLErrors);
                // graphQLErrorsStore.set(graphQLErrors);
                // checkGraphQLErrors(graphQLErrors);
                this.onErrorCallbacks.forEach((callback) => callback(graphQLErrors));
            }
        });
        this.client = client;
    }
}
const client = new GraphQLClient();
export default client;
export { queryMe, mutationAuthUser };
